import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import { QuicklinkModule, QuicklinkStrategy } from "ngx-quicklink";
import { AuthGuard } from "./core/guards/auth/auth.guard";
import { waitForAsync } from "@angular/core/testing";
import { DirtyCheckGuard } from "src/app/core/guards/dirty-check/dirty-check";
import { LogOffGuard } from "src/app/core/guards/dirty-check/logoff.guard";
import { ReloadComponent } from "src/app/reload/reload.component";

//better way to set page title
//https://stackoverflow.com/questions/38644314/changing-the-page-title-using-the-angular-2-new-router

const routes: Routes = [
  {
    path: "",
    redirectTo: "/login",
    pathMatch: "full"
  },
  {
    path: "login",
    loadChildren: () =>
      import("./modules/auth/pages/login/login.page.module").then(
        (m) => m.LoginPageModule
      ),
    canActivate: [LogOffGuard]
  },
  // {
  //   path: 'dashboard',
  //   loadChildren: () =>
  //     import('./modules/account/pages/account-dashboard/account-dashboard.module')
  //       .then(m => m.AccountDashboardPageModule),
  //   canActivate: [AuthGuard],
  //   runGuardsAndResolvers: 'always',
  // },
  {
    path: "__auth",
    loadChildren: () =>
      import(
        "./modules/auth/pages/central-landing/central-landing.module"
      ).then((m) => m.CentralLandingPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: "dashboard",
    loadChildren: () =>
      import("./modules/dashboard/pages/dashboard/dashboard.module").then(
        (m) => m.DashboardPageModule
      ),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always"
  },
  // {
  //   path: 'forgot',
  //   loadChildren: async () =>
  //     import('./modules/auth/pages/auth-reset-password/auth-reset-password.module')
  //       .then(m => m.AuthResetPasswordPageModule)
  // },
  {
    path: "unsubscribe",
    loadChildren: async () =>
      import(
        "./modules/account/pages/account-unsubscribe/account-unsubscribe.module"
      ).then((m) => m.AccountUnsubscribePageModule)
  },
  {
    path: "visitors",
    loadChildren: async () =>
      import(
        "./modules/account/pages/account-visitors/account-visitors.module"
      ).then((m) => m.AccountVisitorsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: "experiences",
    loadChildren: async () =>
      import(
        "./modules/account/pages/account-experiences/account-experiences.module"
      ).then((m) => m.AccountExperiencesPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: "applications",
    loadChildren: async () =>
      import(
        "./modules/account/pages/account-applications/account-applications.module"
      ).then((m) => m.AccountApplicationsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: "institutions",
    loadChildren: async () =>
      import(
        "./modules/institutions/pages/institutions/institutions.module"
      ).then((m) => m.DepartmentsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: "invite-visitors",
    loadChildren: async () =>
      import(
        "./modules/account/pages/account-invite/account-invite.module"
      ).then((m) => m.AccountInvitePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: "application-host/:applicationid",
    loadChildren: async () =>
      import(
        "./modules/application/pages/application-hosting-details/application-hosting-details.module"
      ).then((m) => m.ApplicationHostingDetailsPageModule),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always"
  },
  {
    path: "active-applications",
    loadChildren: async () =>
      import(
        "./modules/account/pages/account-host-active-applications/account-host-active-applications.module"
      ).then((m) => m.AccountHostActiveApplicationsPageModule),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always"
  },
  {
    path: "new-application",
    loadChildren: () =>
      import(
        "./modules/new-application/pages/application/application.module"
      ).then((m) => m.ApplicationPageModule),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always"
  },
  {
    path: "complete-applications",
    loadChildren: async () =>
      import(
        "./modules/account/pages/account-host-complete-applications/account-host-complete-applications.module"
      ).then((m) => m.AccountHostCompleteApplicationsPageModule),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always"
  },
  // {
  //   path: "profile",
  //   loadChildren: async () =>
  //     import(
  //       "./modules/account/pages/account-management-profile/account-management-profile.module"
  //     ).then(m => m.AccountManagementProfilePageModule),
  //   canActivate: [AuthGuard],
  //   runGuardsAndResolvers: "always"
  // },
  {
    path: "settings",
    loadChildren: async () =>
      import(
        "./modules/account/pages/account-settings/account-settings.module"
      ).then((m) => m.AccountSettingsPageModule),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always"
  },
  {
    path: "management/resetrequest/:userid/:hashid",
    loadChildren: async () =>
      import(
        "./modules/auth/pages/password-reset-link/password-reset-link.module"
      ).then((m) => m.PasswordResetLinkPageModule)
  },
  {
    path: "signup/:managerid",
    loadChildren: async () =>
      import("./modules/auth/pages/activation/activation.module").then(
        (m) => m.ActivationPageModule
      )
  },
  {
    path: "hosts",
    loadChildren: async () =>
      import("./modules/host/pages/hosts/hosts.module").then(
        (m) => m.HostsPageModule
      ),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always"
  },
  {
    path: "managers",
    loadChildren: async () =>
      import("./modules/managers/pages/managers/managers.module").then(
        (m) => m.ManagersPageModule
      ),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always"
  },
  {
    path: "trainees",
    loadChildren: async () =>
      import("./modules/trainees/pages/trainee/trainee.module").then(
        (m) => m.TraineePageModule
      ),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always"
  },
  {
    path: "reset-password",
    loadChildren: () =>
      import(
        "./modules/auth/pages/user-set-password/user-set-password.module"
      ).then((m) => m.UserSetPasswordPageModule)
  },
  {
    path: "payments",
    loadChildren: async () =>
      import("./modules/payments/pages/payments/payments.module").then(
        (m) => m.PaymentsPageModule
      ),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always"
  },
  {
    path: "documents",
    loadChildren: async () =>
      import("./modules/documents/pages/documents/documents.module").then(
        (m) => m.DocumentsPageModule
      ),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always"
  },
  {
    path: "reviews",
    loadChildren: async () =>
      import("./modules/reviews/pages/reviews/reviews.module").then(
        (m) => m.ReviewsPageModule
      ),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always"
  },
  {
    path: "review-templates",
    loadChildren: async () =>
      import(
        "./modules/review-templates/pages/review-templates/review-templates.module"
      ).then((m) => m.ReviewTemplatesModule),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always"
  },
  {
    path: "document",
    loadChildren: () =>
      import(
        "./modules/document/pages/view-document/view-document.module"
      ).then((m) => m.ViewDocumentPageModule)
  },
  {
    path: "programs",
    loadChildren: () =>
      import("./modules/programs/pages/program/programs.module").then(
        (m) => m.ProgramsPageModule
      ),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always"
  },
  {
    path: "program-bundles",
    loadChildren: () =>
      import(
        "./modules/program-bundles/pages/program-bundles/program-bundles.module"
      ).then((m) => m.ProgramBundlesPageModule),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always"
  },
  {
    path: "requirements",
    loadChildren: async () =>
      import(
        "./modules/requirements/pages/requirements/requirements.module"
      ).then((m) => m.RequirementsPageModule),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always"
  },
  {
    path: "coupons",
    loadChildren: async () =>
      import("./modules/coupons/pages/coupons/coupons.module").then(
        (m) => m.CouponsPageModule
      ),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always"
  },
  {
    path: "application-requirements-map",
    loadChildren: async () =>
      import(
        "./modules/application-requirement-maps/pages/application-requirement-map/application-requirement-map.module"
      ).then((m) => m.ApplicationRequirementsMapPageModule),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always"
  },
  {
    path: "itineraries",
    loadChildren: async () =>
      import("./modules/itineraries/pages/itineraries/itineraries.module").then(
        (m) => m.ItinerariesPageModule
      ),
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always"
  },
  {
    path: ".",
    component: ReloadComponent,
    canActivate: [AuthGuard],
    runGuardsAndResolvers: "always"
  },
  {
    path: "**",
    loadChildren: () =>
      import("./modules/auth/pages/page-not-found/page-not-found.module").then(
        (m) => m.PageNotFoundPageModule
      )
  }
];

@NgModule({
  imports: [
    QuicklinkModule,
    RouterModule.forRoot(routes, {
      preloadingStrategy: QuicklinkStrategy,
      // onSameUrlNavigation: 'reload',
      relativeLinkResolution: "legacy"
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
